import Promise from 'promise-polyfill'
import isWidgetHalfVisible from './is-widget-half-visible'

export default widgetUuid =>
  new Promise(resolve => {
    const timer = () =>
      setTimeout(() => {
        const widgetInstance = window._8select.utils.widgetLoader.find(widgetUuid)
        const widgetHasBeenSeen = isWidgetHalfVisible(widgetInstance)

        if (!widgetHasBeenSeen) {
          return timer()
        }

        resolve()
      }, 300)

    timer()
  })
